<mat-toolbar
  color="secondary"
  class="global-header tw-py-0 tw-pl-2 lg:!tw-pr-0"
  *ngIf="user">
  <img src="assets/images/lendio-icon-256x256.png" style="height:34px" />
  <app-navbar class="tw-pl-2 tw-hidden lg:tw-block" [user]="user"></app-navbar>
  <div class="tw-flex-grow"></div>
  <button
    *ngIf="canSubmitCxInteractions"
    mat-icon-button
    class="gh-button mat-elevation-z0"
    data-cy="cx-interaction"
    (click)="handleCxDrawer()">
    <mat-icon>label_outline</mat-icon>
  </button>
  <div class="tw-mx-2" *ngIf="user?.settings?.outOfOffice">
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect
        width="18"
        height="18"
        rx="9"
        fill="#E60D0D">
        <title>New Assignments Paused</title>
      </rect>
    </svg>
  </div>
  <div class="tw-hidden xl:tw-block lg:tw-block">
    <a
      mat-icon-button
      class="gh-button mat-elevation-z0"
      data-cy="sales-playbook"
      href="https://sites.google.com/lendio.com/sales-playbook/home"
      target="_blank">
      <mat-icon>book</mat-icon>
    </a>
  </div>
  <app-direct-dial></app-direct-dial>
  <button
    mat-icon-button
    class="gh-button mat-elevation-z0"
    data-cy="notifications-history"
    (click)="handleNotificationDrawer(); $event.stopPropagation();">
    <mat-icon
      [matBadgeHidden]="!(unreadNotifications$ | async)"
      [matBadge]="(unreadNotifications$ | async)"
      matBadgeColor="primary"
      matBadgeSize="medium">
      notifications</mat-icon>
  </button>
  <app-reminders-today-smart></app-reminders-today-smart>
  <app-add-to-queue-dropdown class="tw-hidden xl:tw-block lg:tw-block"></app-add-to-queue-dropdown>
  <app-user-menu class="tw-pl-2" [user]="user"></app-user-menu>
  <app-borrower-search-input class="tw-hidden xl:tw-block xl:tw-pr-4" [user]="user" (borrower)="viewBorrower($event)"></app-borrower-search-input>
  <div *ngIf="isMobile">
    <button
      [matMenuTriggerFor]="mobileMenu"
      mat-icon-button
      class="gh-button mat-elevation-z0 tw-visible lg:tw-hidden tw-flex tw-align-middle"
      color="white">
      <mat-icon>menu</mat-icon>
      <mat-menu #mobileMenu>
        <button mat-menu-item (click)="handleMobileRoute('tasks')">Inbox</button>
        <button mat-menu-item (click)="handleMobileRoute('businesses')">Businesses</button>
        <button mat-menu-item (click)="handleMobileRoute('new-businesses')">New Businesses</button>
        <button mat-menu-item (click)="handleMobileRoute('funnel')">Funnel</button>
        <button *ngIf="canViewDealsTab" mat-menu-item (click)="handleMobileRoute('deals')">Deals</button>
        <button mat-menu-item (click)="handleMobileRoute('performance')">Performance</button>
        <button *ngIf="canViewCxPerfTab" mat-menu-item (click)="handleMobileRoute('cxPerformance')">CX Performance</button>
      </mat-menu>
    </button>
  </div>
</mat-toolbar>
